import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';
import { fadeInOutAnimation } from '../../../../functions/animations/fade-in-out.animation';

@Component({
  selector: 'app-input-error',
  template: `<span class="error-message">{{ message }}</span>`,
  styleUrls: ['./input-error.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  animations: [fadeInOutAnimation],
})
export class InputErrorComponent {
  @HostBinding('@fadeInOut') fadeInOut = true;
  @Input({ required: true }) message!: string;
}
